import { RootState } from "app/store";
import { dossierExportsAdapter } from "./state";

const selectIsLoadingDossierExports = (state: RootState) =>
    state.cases.caseExports.isLoadingDossierExports ?? false;
const selectErrorLoadingDossierExports = (state: RootState) =>
    state.cases.caseExports.errorLoadingDossierExports;
const selectTotalDossierExports = (state: RootState) =>
    state.cases.caseExports.totalDossierExports;

const { selectAll: selectAllDossierExports } =
    dossierExportsAdapter.getSelectors(
        (state: RootState) => state.cases.caseExports.dossierExports,
    );

export const dossierExportSelectors = {
    selectAllDossierExports,
    selectTotalDossierExports,
    selectIsLoadingDossierExports,
    selectErrorLoadingDossierExports,
};
